<template>
  <div class="layout-px-spacing">
    <teleport to="#breadcrumb">
      <ul class="navbar-nav flex-row">
        <li>
          <div class="page-header">
            <nav class="breadcrumb-one" aria-label="breadcrumb">
              <ol class="breadcrumb">
                <li class="breadcrumb-item active" aria-current="page"><span>{{ $t('Blog') }}</span></li>
              </ol>
            </nav>
          </div>
        </li>
      </ul>
    </teleport>

    <div class="row layout-top-spacing">
      <div class="col-xl-12">
        <div class="d-flex align-items-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="feather feather-arrow-left" data-v-02c2cbc4="">
            <line x1="19" y1="12" x2="5" y2="12"></line>
            <polyline points="12 19 5 12 12 5"></polyline>
          </svg>
          <router-link class="text-primary" tag="a" :to="{ name: 'BlogList' }">{{ $t('Back') }}</router-link>
        </div>
      </div>
    </div>
    <div class="row layout-top-spacing">
      <div class="col-xl-12 col-lg-12 col-md-12 col-12 layout-spacing">
        <div class="panel br-4">
          <div class="panel-body">
            <form @submit.prevent="actionForm">
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm" for="title">{{ $t('Title') }}</label>
                <div class="col-sm-10">
                  <input type="text" class="form-control" v-model="formData.title"
                    :class="[hasFormError.title ? (hasFormError.title ? 'is-invalid' : '') : '']"
                    :placeholder="$t('Enter') + ' ' + $t('Title')" @blur="blogStore.removeErrorFormSingle('title')" />
                  <div v-if="hasFormError.title" class="invalid-feedback">{{ hasFormError.title }}</div>
                </div>
              </div>
              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm" for="title">{{ $t('Blog') }}</label>
                <div class="col-sm-10">
                  <quill-editor v-model:value="formData.content" :options="options1"
                    @blur="blogStore.removeErrorFormSingle('content')"></quill-editor>
                  <div v-if="hasFormError.content" class="text-danger fw-bold">{{ hasFormError.content }}</div>
                </div>
              </div>

              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm">
                  {{ $t('Upload Cover Image') }}
                </label>
                <div class="col-sm-10">
                  <div class="custom-file mb-3">
                    <input id="ufile" type="file" class="custom-file-input" @change="uploadMainImage" />
                    <label for="ufile" data-browse="Browse" class="custom-file-label">
                      <span class="d-block form-file-text">{{ $t('Choose File') }}</span>
                    </label>
                  </div>

                  <ul class="list-group list-group-media mt-4" v-if="formData.image">
                    <li class="list-group-item list-group-item-action">
                      <div class="media mb-0">
                        <div class="me-3">
                          <img :src="formData.image_collect.file_url" class="img-fluid" style="height:30rem;" />
                        </div>
                        <div class="media-body d-flex align-items-center">
                          <h6 class="tx-inverse">
                            {{ formData.image_collect.file_name }}
                            (<span class="tx-success">{{ formData.image_collect.file_size }}</span>)
                          </h6>
                          <a v-if="action !== 'view'" href="javascript:void(0)" @click="deleteMainImage"
                            class="text-danger fw-bold mb-2 ms-3">
                            {{ $t('Delete') }}
                          </a>
                        </div>
                      </div>
                    </li>

                  </ul>
                </div>
              </div>

              <div class="row mb-4">
                <label class="col-sm-2 col-form-label col-form-label-sm" for="title">
                  {{ $t('Upload Gallery Image') }}
                </label>
                <div class="col-sm-10">
                  <div class="custom-file mb-3">
                    <input id="ufile2" type="file" class="custom-file-input" @change="uploadGalleryImage" multiple />
                    <label for="ufile2" data-browse="Browse" class="custom-file-label">
                      <span class="d-block form-file-text">{{ $t('Choose File') }}</span>
                    </label>
                  </div>

                  <ul class="list-group list-group-media mt-4" v-if="formData.list_media_collect">
                    <li class="list-group-item list-group-item-action" v-for="item in formData.list_media_collect"
                      :key="item.file_id">
                      <div class="media mb-0">
                        <div class="me-3">
                          <img :src="item.file_url" class="img-fluid rounded-circle"
                            style="height:10rem;width:10rem;" />
                        </div>
                        <div class=" media-body d-flex align-items-center">
                          <h6 class="tx-inverse">
                            {{ item.file_name }}
                            (<span class="tx-success">{{ item.file_size }}</span>)
                          </h6>
                          <a v-if="action !== 'view'" href="javascript:void(0)"
                            @click="deleteGalleryImage(item.file_id)" class="text-danger fw-bold mb-2 ms-3">
                            {{ $t('Delete') }}
                          </a>
                        </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="row">
                <template v-if="hasErrorSingle">
                  <div class="col-12">
                    <div class="alert alert-light-danger alert-dismissible border-0 mb-4" role="alert">
                      <strong>{{ $t('Failed') }}</strong> {{ hasErrorSingle }}
                      <button type="button" class="close" data-bs-dismiss="alert" aria-label="Close">×</button>
                    </div>
                  </div>
                </template>
                <div class="col-12 col-md-4 offset-md-8">
                  <template v-if="action == 'view'">
                  </template>
                  <template v-else>
                    <button type="submit" class="btn btn-primary btn-lg" :disabled="isLoadingForm">
                      <span v-if="isLoadingForm" class="spinner-border text-white me-2 align-self-center loader-sm">
                        Loading...
                      </span>
                      {{ $t('Save') }}
                    </button>
                    &nbsp;
                    <button @click="blogStore.resetForm" type="button" class="btn btn-danger btn-lg">
                      {{ $t('Cancel') }}
                    </button>
                  </template>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useBlogStore } from '@/store/blog/blogStore';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { quillEditor } from 'vue3-quill';

const { t } = useI18n();
const blogStore = useBlogStore();
const { formData, hasFormError, isLoadingForm, hasErrorSingle, isSuccess } = storeToRefs(blogStore);
const route = useRoute();
const router = useRouter()
blogStore.resetForm();

const options1 = ref({
  modules: {
    toolbar: [[{ header: [1, 2, false] }], ['bold', 'italic', 'underline'], ['image', 'code-block']],
  },
  placeholder: t('Enter') + ' ' + t('Blog'),
  theme: 'snow'
});

const idData = ref('');
const action = ref(route.query.act);
const listAction = ['edit', 'view'];
if (listAction.includes(route.query.act)) {
  idData.value = route.query.id;
  blogStore.getDataDetail(idData.value);
}

const actionForm = async () => {
  if (action.value == 'edit') {
    await blogStore.updateData(idData.value);
    if (isSuccess.value) {
      new window.Swal({
        icon: 'success',
        title: t('Success'),
        padding: '2em',
      });
      router.push({ name: 'BlogList' });
    }
  } else if (action.value == 'view') {
    // console.log('view');
  } else {
    await blogStore.saveData();
    if (isSuccess.value) {
      new window.Swal({
        icon: 'success',
        title: t('Success'),
        padding: '2em',
      });
    }
  }
}

// upload main image
const uploadMainImage = async (e) => {
  const file = e.target.files[0];
  if (file) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('type', 'IMAGE');
    await blogStore.uploadFile(formData, 'MAIN_IMAGE');
  }
}
const deleteMainImage = () => {
  formData.value.image = null;
  formData.value.image_collect = null;
}

// upload gallery image
const uploadGalleryImage = async (e) => {
  const files = e.target.files;
  if (files) {
    for (let i = 0; i < files.length; i++) {
      const formData = new FormData();
      formData.append('file', files[i]);
      formData.append('type', 'IMAGE');
      await blogStore.uploadFile(formData, 'GALLERY_IMAGE');
    }
  }
}
const deleteGalleryImage = (id) => {
  formData.value.list_media = formData.value.list_media.filter(item => item != id);
  formData.value.list_media_collect = formData.value.list_media_collect.filter(item => item.file_id != id);
}

</script>

<style scoped>
.ql-container.ql-snow {
  height: 500px;
  overflow-y: auto;
}
</style>
